import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useOvermind } from '../../overmind'
import GoogleBtn from '../../login/GoogleBtn'
import Box from '@material-ui/core/Box';


function Authenticated() {
  const { state, actions } = useOvermind();

  const loggedOut = () =>{
    console.log('I logged out');
    actions.updateFlag({'name':'redirectPath','payload':'/'});
    actions.setGoogleAccessToken({googleAccessToken:undefined});
    actions.getAccountList(undefined);
    actions.setAccountIndex('reset');
    actions.getContainerList(undefined);
    actions.setContainerIndex('reset');
    actions.setBlockAccess(true);
    actions.addFormattedData({'name':'liveContainerConfig', 'payload':undefined});
    actions.addFormattedData({'name':'tagDataTable', 'payload':undefined});
    actions.addFormattedData({'name':'variableDataTable', 'payload':undefined});
    actions.addFormattedData({'name':'triggerDataTable', 'payload':undefined});
    localStorage.removeItem('sid');
  }

    return(
      <div>
      <Box display="flex" >
        <Box m="auto">
          <Typography align="center"> Hello {state.authState.firstName}! </Typography>
          <Typography align="center"> You are currently logged in as <b>{state.authState.email}</b>.</Typography>
          <Typography align="center"> If you want use a different login Logout and try again</Typography>
          <Box m="auto" width={100}>
            <GoogleBtn isLogined={true} loggedOut={loggedOut}/>
          </Box>
        </Box>
      </Box>
      </div>
    );

}
function NotAuthenticated() {
  const { state, actions } = useOvermind();

  const getGoogleAccessToken = (authstate) => {
    actions.setGoogleAccessToken(authstate);
    actions.setBlockAccess(false);
    actions.setActiveStep(1)
    console.log('inside getGoogleAccessToken')
    console.log(JSON.stringify(state.authState))
  }

    return(
      <div>
        <Box display="flex" >
          <Box m="auto">
            <Typography align="center"> Hello! </Typography>
            <Typography align="center"> You don't seem to be logged in.</Typography>
            <Typography align="center"> Please login to your Google Account</Typography>
            <Box m="auto" width={190}>
              <GoogleBtn label = "Login in with Google" googleAccessToken={getGoogleAccessToken}/>
            </Box>
          </Box>
        </Box>
      </div>
    );
}


export default function Step1Login() {
  const { state } = useOvermind();

  return (
    <Grid container direction="column" justify="center" alignItems="center" spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        {(typeof state.authState.googleAccessToken === 'undefined')?<NotAuthenticated/>:<Authenticated/>}
      </Grid>

    </Grid>

  );
}
